export default angular
  .module("HeaderCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("HeaderController", [
    "$modal",
    "$scope",
    "$state",
    "$http",
    "$rootScope",
    "$translate",
    "Message",
    "System",
    "Permissions",
    function ($modal, $scope, $state, $http, $rootScope, $translate, Message, System, Permissions) {
      $scope.unread = [];
      $scope.languages = [];
      $scope.unread.NUMBER_OF_UNREAD_MESSAGES = "-";
      $scope.$state = $state;
      if ($rootScope.loggedUser) {
        $scope.username = $rootScope.loggedUser.fullname;
        $scope.language = $rootScope.loggedUser.language;
        $scope.country = $rootScope.loggedUser.country;
      }

      $scope.permissions = Permissions.getUserPermissions($rootScope.loggedUser);

      $scope.isLoggedIn = $rootScope.loggedIn;

      $scope.logout = function () {
        $http
          .get("/logout")
          .success(() => {
            $state.go("login");
          })
          .error(() => {});
      };

      Message.loadCountUnreadMessages((data) => {
        $scope.unread = data[0];
      });

      System.loadLanguages((data) => {
        $scope.languages = data;
      });

      System.loadCountries((data) => {
        $scope.countries = data;
      });

      $scope.openCompilerModal = function () {
        $modal.open({
          animation: true,
          size: "md",
          templateUrl: "view/modal/compiler.html",
          backdrop: "static",
          controller: "CompilerController",
        });
      };

      $scope.openGeneratePostmanTestsModal = function () {
        $modal.open({
          animation: true,
          size: "md",
          templateUrl: "view/modal/generatePostmanTests.html",
          backdrop: "static",
          controller: "GenerateTestsController",
        });
      };

      $scope.setLanguage = function (language) {
        $rootScope.loggedUser.language = language.ABBREVIATION;
        $scope.language = $rootScope.loggedUser.language;
      };

      $scope.setCountry = function (country) {
        $rootScope.loggedUser.country = country.ABBREVIATION;
        $scope.country = $rootScope.loggedUser.country;
      };
    },
  ]);
